import { motion } from "framer-motion";

const services = [
  {
    n: "01",
    title: "ABA Therapy",
    img: "https://images.unsplash.com/photo-1484820540004-14229fe36ca4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxjaGlsZCUyMHRoZXJhcGlzdCUyMHBsYXlpbmclMjBibG9ja3N8ZW58MHx8fHwxNzg1NzQ2NTU3fDA&ixlib=rb-4.1.0&q=85",
    desc: "One-to-one Applied Behavior Analysis built around your child. We use positive reinforcement to grow communication, social and daily-living skills at a pace that feels natural and joyful.",
    points: ["Play-based sessions", "Parent coaching", "Progress tracking"],
  },
  {
    n: "02",
    title: "Early Intervention Assessments",
    img: "https://images.unsplash.com/flagged/photo-1551887373-6edba6dacbb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxjaGlsZCUyMHNtaWxpbmclMjByZWFkaW5nJTIwYm9vayUyMHRoZXJhcGlzdHxlbnwwfHx8fDE3ODU3NDY1NTd8MA&ixlib=rb-4.1.0&q=85",
    desc: "Comprehensive developmental assessments that identify strengths and needs early. You leave with a clear, compassionate roadmap and honest, practical next steps.",
    points: ["Developmental screening", "Detailed reports", "Family guidance"],
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
          className="max-w-2xl mb-16 md:mb-24"
        >
          <p className="text-sm tracking-[0.2em] uppercase text-brand-secondary mb-5">What we do</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl tracking-tight text-brand-primary">
            Two focused services, one caring goal.
          </h2>
        </motion.div>

        <div className="space-y-24 md:space-y-32">
          {services.map((s, i) => (
            <motion.div
              key={s.n}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
              data-testid={`service-card-${i}`}
              className={`grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-center ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="lg:col-span-6">
                <div className="relative">
                  <div
                    className={`absolute -z-0 h-full w-full rounded-3xl bg-brand-accent ${
                      i % 2 === 1 ? "-right-5 -bottom-5" : "-left-5 -bottom-5"
                    }`}
                  />
                  <div className="relative overflow-hidden rounded-3xl">
                    <img
                      src={s.img}
                      alt={s.title}
                      className="h-[320px] sm:h-[420px] w-full object-cover hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                </div>
              </div>

              <div className="lg:col-span-6">
                <span className="font-display text-6xl text-brand-primary/15">{s.n}</span>
                <h3 className="font-display text-2xl sm:text-3xl text-brand-primary mt-2 mb-5">
                  {s.title}
                </h3>
                <p className="text-lg text-brand-ink/70 leading-relaxed max-w-lg">{s.desc}</p>
                <ul className="mt-8 flex flex-wrap gap-3">
                  {s.points.map((p) => (
                    <li
                      key={p}
                      className="rounded-full border border-brand-primary/15 px-4 py-2 text-sm text-brand-primary"
                    >
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
